import apiConfig from '../../../apiConfig';

export type StoreForReserve = {
  id: number;
  name: string;
  location: string | null;
  tel: string | null;
  telegram_url?: string | null;
  instagram_url?: string | null;
  tiktok_url?: string | null;
  messenger_url?: string | null;
};

export type ListStoresForStaffReserveResponse = {
  stores: StoreForReserve[];
};

export const fetchStoresForStaffReserve = async (): Promise<StoreForReserve[]> => {
  const res = await fetch(`${apiConfig.baseURL}/api/customer-app/reservation/by-staff/stores`, {
    method: 'GET',
  });

  if (!res.ok) {
    throw new Error('Failed to fetch stores (by-staff)');
  }

  const data = (await res.json()) as ListStoresForStaffReserveResponse;
  return data.stores ?? [];
};
